import { render, staticRenderFns } from "./AmendStandingOrder.vue?vue&type=template&id=b4d682f0"
import script from "./AmendStandingOrder.vue?vue&type=script&lang=js"
export * from "./AmendStandingOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports